import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../service/authentication.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private readonly _authenticationService = inject(AuthenticationService);

  /**
   * Add auth header with jwt if user is logged in and request is to api url
   * @param request
   * @param next
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const currentUser = this._authenticationService.currentUserValue;
    const isLoggedIn = currentUser?.token;
    const isApiUrl =
      request.url.startsWith(environment.mainapiUrl) ||
      request.url.startsWith(environment.messagingUrl) ||
      request.url.startsWith(environment.dispatchUrl);
    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`,
          'Accept-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      });
    }

    return next.handle(request);
  }
}
